import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { debounceTime, fromEvent } from 'rxjs'
import { Content } from '@monorepo/golab-generated'

const titleBarHeight = 64
const topPadding = 43
const bottomPadding = 12
const heightOverhead = titleBarHeight + topPadding + bottomPadding + 32

const preziUrlRegExp = /https?:\/\/prezi\.com\//s
const preziEmbedUrlBegin = 'https://prezi.com/embed/'
const preziIdRegExp = /https?:\/\/prezi\.com\/([a-z0-9_]*)\//s

@Component({
  selector: 'app-web-page-content',
  templateUrl: './web-page-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./web-page-content.component.scss'],
})
export class WebPageContentComponent implements AfterViewInit, OnDestroy {
  private readonly domSanitizer = inject(DomSanitizer);

  @ViewChild('webPageIframe') iframe: ElementRef<HTMLIFrameElement> | undefined
  webUrl: SafeResourceUrl
  @Input() phaseId: string = ''

  constructor() {
    this.webUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('')
    fromEvent(window, 'resize')
      .pipe(takeUntilDestroyed(), debounceTime(200))
      .subscribe(() => this.adjustIFrameHeight())
  }

  private _content: Content | undefined

  get content(): Content | undefined {
    return this._content
  }

  @Input() set content(content: Content | undefined) {
    if (content) {
      this.setWebUrl(content.url ? content.url : '')
    }
    this._content = content
  }

  ngAfterViewInit(): void {
    if (this._content?.url) {
      this.adjustIFrameHeight()
    }
  }

  ngOnDestroy() {}

  private setWebUrl(url: string): void {
    const lowerCaseUrl = url.toLowerCase()
    if (preziUrlRegExp.test(lowerCaseUrl)) {
      const preziId = lowerCaseUrl.match(preziIdRegExp)
      if (preziId && preziId.length > 1 && preziId[1] !== 'embed') {
        url = preziEmbedUrlBegin + preziId[1]
      }
    }
    this.webUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url)
    if (url) {
      this.adjustIFrameHeight()
    }
  }

  private adjustIFrameHeight() {
    if (this.iframe) {
      const desiredHeight = window.innerHeight - heightOverhead
      const iframe = this.iframe.nativeElement
      iframe.style.height = desiredHeight + 'px'
      // console.log('iframe height: ' + iframe.style.height)
    } else {
      console.log('iframe not found')
    }
  }
}
